export function useRedirectUri(): { redirectUri: string } {
  const redirectUri = window.location.pathname + window.location.search
  return { redirectUri }
}
